import { Route, Navigate, Routes } from "react-router-dom";
import "./App.scss";

// components
import { PageLayout } from "@/views/PageLayout";

// routes
import NotFound from "../NotFound";
import Dashboard from "../Dashboard";
import { SwapPage } from "../Swap";
import { RedeemPage } from "../Redeem";
import { BridgePage } from "../Bridge";
import { StakePage } from "../Stake";
import { MintPage } from "../Mint";

export function App() {
  return (
    <div className='app'>
      <PageLayout>
        <Routes>
          <Route path='/' element={<Navigate to='/dashboard' replace />} />
          <Route path='/dashboard' element={<Dashboard />} />
          <Route path='/swap' element={<SwapPage />} />
          <Route path='/mint' element={<MintPage />} />
          <Route path='/redeem' element={<RedeemPage />} />
          <Route path='/bridge' element={<BridgePage />} />
          <Route path='/stake' element={<StakePage />} />
          <Route path='*' element={<NotFound />} />
        </Routes>
      </PageLayout>
    </div>
  );
}
